// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".infoBox[data-v-70063cd6] {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  padding: 0 20px;\n  padding-bottom: 20px;\n}\n.infoBox > div[data-v-70063cd6] {\n  width: 33.3333%;\n  line-height: 30px;\n}\n.nameBox[data-v-70063cd6] {\n  font-weight: bold;\n  margin: 20px 0;\n  padding-left: 7%;\n  font-size: 20px;\n}", ""]);
// Exports
module.exports = exports;
